import { APIs } from "../constants/APIConstants";
import api from "./api";

export default class SurveyAPI {
    putRating(req) {
        return api.put(APIs.SURVEY_RATTING, req);
    }

    putComment(req) {
        return api.put(APIs.SURVEY_COMMENT, req);
    }
}
